
export const Messages = {

    error : 'Please fill all the required fields with valid input',
    weightageError:'Total Weightage must be 100',
    loginSuccess: 'Login Successful',
    otpSucess: 'OTP Verified Successfully',
    linkLocationSuccess:'Successfully linked',
    success: 'Success',
    saved: 'Saved',
    updated: 'Updated',
    deleted: 'Deleted',
    downloadReport: 'Complete',
    chooseDate: 'Please choose Date',
    dateValidate: 'Start Date must be less than End Date',
    noData: 'No Data Found',
    passwordChange : 'Password changed,Can you please login again',
    bankResultForSuccess: 'Bank verification successfully',
    validateForNumber: 'Please enter a valid Account or Mobile Number',
    validateForAppcode: 'Please choose Application code',
    validateForAllAppcode: 'Please select an application code other than ALL',
    validateForMerchantName: 'Please enter merchant name to search',
    validateForComments: 'Please enter comments',
    validInput: 'Please enter valid input',
    validateForNoNumber: 'Mobile/ Account number not found',
    noImage: 'No Image Found',
    noDateSelected: 'Please select date range',
    unKnownError: 'There was an Network/ Unknown error while processing the request. Please contact the support team.',
    fileLargeError : 'The uploaded image is may be large,can you please try with another image',
    imageTypeError : 'The uploaded file type is not supported.',
    sessionExpired : 'Session has expired, please login again!',
    limitSelection : 'please select 10 numbers!',
    validateVoucherSelection: 'Please choose a voucher',
    merchantCompany:'Merchant’s Shareholder Details Added Successfully',
    merchantContact:'Merchant’s Shareholder Details Added Successfully',
    merchantDirector:'Merchant’s Director Details Added Successfully',
    merchantAp:'Merchant’s Authorized Representatives Details Added Successfully',
    merchantForm:'Please fill in the last shareholder company details before adding a new one',
    merchantOnlinestore:'Merchant online store details added sucessfully',
    merchantOutletDetails:'Merchant outlet details added sucessfully',
    merchantFinanceBilling:'Merchant finance and billing details added sucessfully',
    countryErrorMessage: 'Remittance provider currency already available',
    duplicateCountryErrorMessage: 'Remittance provider country already available',
    selectAppcodeOtherThanAll:'Please select an appcode other than All',
    docSignature:'Link has been successfully sent to the Director',
    bulkQR:'QR code has been sent to your mail shortly',
    transactionTimeLimit: 'Transaction time limit saved successfully',
};
